import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CreateCommitteeApiData {
  createCommittee: Record<string, any>;
  standard: Record<string, any>[];
  harmonized: Record<string, any>[];
  configureCommittee: Record<string, any>;
  addMembersInCommittee: Record<string, any>;
  categoryOfIntereset: Record<string, any>[];
  adminData: Record<string, any>;
  loading: boolean;
  managersData: Record<string, any>[];
  isLeadPMorPM?: boolean;
  isAddedConfiguration?: boolean;
  isParentCommitteeChange?: boolean;
}

const initialState: CreateCommitteeApiData = {
  createCommittee: {},
  standard: [],
  harmonized: [],
  configureCommittee: {},
  addMembersInCommittee: {},
  categoryOfIntereset: [],
  adminData: {},
  loading: false,
  managersData: [],
  isLeadPMorPM: false,
  isAddedConfiguration: false,
  isParentCommitteeChange: false,
};

const createCommitteeSlice = createSlice({
  name: "Committee",
  initialState,
  reducers: {
    createCommitteeRequest: (
      state,
      action: PayloadAction<Record<string, any>>,
    ) => {
      state.createCommittee = { ...state.createCommittee, ...action.payload };
      state.loading = false;
    },
    addManagerData: (state, action: PayloadAction<Record<string, any>[]>) => {
      state.managersData = action.payload;
      state.loading = false;
    },
    createStandardCommitteeRequest: (
      state,
      action: PayloadAction<Record<string, any>[]>,
    ) => {
      state.standard = action.payload;
      state.loading = false;
    },
    createHarmonizedCommitteeRequest: (
      state,
      action: PayloadAction<Record<string, any>[]>,
    ) => {
      state.harmonized = action.payload;
      state.loading = false;
    },
    configureCommitteeRequest: (
      state,
      action: PayloadAction<Record<string, any>>,
    ) => {
      state.configureCommittee = {
        ...state.configureCommittee,
        ...action.payload,
      };
      state.loading = false;
    },
    adminData: (state, action: PayloadAction<Record<string, any>>) => {
      state.adminData = {
        ...state.adminData,
        ...action.payload,
      };
      state.loading = false;
    },
    addMembersInCommitteeRequest: (
      state,
      action: PayloadAction<Record<string, any>>,
    ) => {
      state.addMembersInCommittee = {
        ...state.addMembersInCommittee,
        ...action.payload,
      };
      state.loading = false;
    },
    categoryOfInteresetRequest: (
      state,
      action: PayloadAction<Record<string, any>[]>,
    ) => {
      state.categoryOfIntereset = action.payload;
      state.loading = false;
    },
    categoryOfInteresetReset: (state) => {
      state.categoryOfIntereset = [];
      state.loading = false;
    },
    addMembersInCommitteeReset: (state) => {
      state.addMembersInCommittee = {};
      state.loading = false;
    },
    setIsLeadPMorPM: (state, action: PayloadAction<boolean>) => {
      state.isLeadPMorPM = action.payload;
      state.loading = false;
    },
    setConfiguration: (state, action: PayloadAction<boolean>) => {
      state.isAddedConfiguration = action.payload;
      state.loading = false;
    },

    setParentcommitteeChange: (state, action: PayloadAction<boolean>) => {
      state.isParentCommitteeChange = action.payload;
      state.loading = false;
    },

    setParentCheck: (state, action: PayloadAction<boolean>) => {
      state.configureCommittee = {
        ...state.configureCommittee,
        defaultParent: action.payload,
      };
      state.loading = false;
    },

    reset: () => ({
      ...initialState,
      createCommittee: {},
      standard: [],
      harmonized: [],
      configureCommittee: {},
      addMembersInCommittee: {},
      categoryOfIntereset: [],
      adminData: {},
      managersData: [],
    }),
  },
});

export const {
  createCommitteeRequest,
  configureCommitteeRequest,
  adminData,
  addMembersInCommitteeRequest,
  categoryOfInteresetRequest,
  addManagerData,
  reset,
  categoryOfInteresetReset,
  addMembersInCommitteeReset,
  createHarmonizedCommitteeRequest,
  createStandardCommitteeRequest,
  setIsLeadPMorPM,
  setConfiguration,
  setParentcommitteeChange,
  setParentCheck,
} = createCommitteeSlice.actions;
export default createCommitteeSlice.reducer;
